module.exports = __webpack_public_path__ + "static/media/experienceddentist.e6c521bb.png";